import React from "react";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import { Text } from "components/Typography/text.styled";
import { TipTabStyled, TipTabsStyled } from "../tips.styled";

type TipCreditTabsProps = {
  activeTab: "tips" | "credit";
  setActiveTab: (tab: "tips" | "credit") => void;
};

export const TipCreditTabs: React.FC<TipCreditTabsProps> = (props) => {
  const { t } = useTranslation();

  return (
    <TipTabsStyled style={{ justifyContent: "center", userSelect: "none" }}>
      <TipTabStyled
        active={props.activeTab === "tips"}
        onClick={() => props.setActiveTab("tips")}
      >
        <Text
          fontSize={FontSize.Large}
          fontFamily={
            props.activeTab === "tips"
              ? FontFamily.MontserratSemiBold
              : FontFamily.MontserratRegular
          }
        >
          {t("CompanyTip.Tip")}
        </Text>
      </TipTabStyled>

      <TipTabStyled
        active={props.activeTab === "credit"}
        onClick={() => props.setActiveTab("credit")}
      >
        <Text
          fontSize={FontSize.Large}
          fontFamily={
            props.activeTab === "credit"
              ? FontFamily.MontserratSemiBold
              : FontFamily.MontserratRegular
          }
        >
          {t("TipCredit.DepositsAndWithdrawals")}
        </Text>
      </TipTabStyled>
    </TipTabsStyled>
  );
};
